import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  trackLandingPageType: 'lead',
  emailSuggestionEnabled: true,
  redirectOnSuccessUrl: '/fr-be/booking/{hash}/',
  featuresFlags: {
    postalCode: false,
    honeyPotEmail: false,
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
    dropOffEmailDelayInMinutes: 20
  },
  abExperiment: initialPropsExperimentConfig.carleadCreation,
};

/**
 * @type {import('@wkda/internal-types').FlowObject}
 */
export const step1Flow = {
  initial: {
    name: 'manufacturer',
    next: ['mainType'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  mainType: {
    name: 'mainType',
    next: ['builtDate'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  builtDate: {
    name: 'builtDate',
    next: ['bodyType'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  bodyType: {
    name: 'bodyType',
    next: ['mainTypeDetail'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  mainTypeDetail: {
    name: 'mainTypeDetail',
    next: ['mainTypeSub'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  mainTypeSub: {
    name: 'mainTypeSub',
    next: ['mileage'],
    nodeType: 'dataField',
    inputFieldType: 'select',
  },
  mileage: {
    name: 'mileage',
    next: ['SELLPOINT'],
    nodeType: 'normalField',
    inputFieldType: 'text',
  },
  SELLPOINT: {
    name: 'SELLPOINT',
    next: ['SELL_TYPES', 'email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      SELL_TYPES: ['SELLPOINT_NOW', 'SELLPOINT_4_WEEKS', 'SELLPOINT_3_MONTHS'],
      email: ['SELLPOINT_NOT_PLANNED'],
    },
  },
  SELL_TYPES: {
    name: 'SELL_TYPES',
    next: ['email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      email: ['PRIVATE', 'DEALER'],
    },
  },
  email: {
    name: 'email',
    next: ['finish'],
    nodeType: 'normalField',
    inputFieldType: 'text',
  },
  finish: {
    name: 'finish',
    nodeType: 'normalField',
    inputFieldType: 'select',
    next: [],
  },
};
